export default __webpack_public_path__ + "static/card-6-07d17ee79e83e71b014e410aa153aba1.png";